import { render, staticRenderFns } from "./operationalStatistics.vue?vue&type=template&id=b8f605b2&scoped=true"
import script from "./operationalStatistics.vue?vue&type=script&lang=js"
export * from "./operationalStatistics.vue?vue&type=script&lang=js"
import style0 from "./operationalStatistics.vue?vue&type=style&index=0&id=b8f605b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f605b2",
  null
  
)

export default component.exports